import { render, staticRenderFns } from "./ExcelDropZone.vue?vue&type=template&id=66232628&"
import script from "./ExcelDropZone.vue?vue&type=script&lang=js&"
export * from "./ExcelDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports